import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {SL5AnagrafService} from '../../general-services/service-sl5-anagraf/sl5-anagraf.service';
import {L3Model} from '../../../models/L3Model';
import * as toastr from 'toastr';
import {Router} from '@angular/router';
import {LoaderService} from '../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-l3-anagraf',
  templateUrl: './sl5-anagraf.component.html',
  styleUrls: ['./sl5-anagraf.component.scss']
})
export class Sl5AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  displayedColumns: Array<string>;
  dataSource: any;
  l3Url: string;
  isMocked: boolean;
  isAnagraphSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  filter: L3Model;
  offset: Offset;
  pageSize: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;

  @Output() elementSelected = new EventEmitter();



  constructor(private sl5AnagrafService: SL5AnagrafService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.l3Url = servers.apiUrl + urls.cobidbService + urls.sl5;
    this.showActions = true;
    this.selectedRowIndex = -1;
    this.filter = new L3Model();
  }

  ngOnInit() {
    this.isMocked = false;
    if (this.showActions) {
      this.displayedColumns = ['L3Cod', 'l3Desc', 'inArchStructSett', 'actions'];
    } else {
      this.selectedRowIndex = this.idSelected;
      this.displayedColumns = ['L3Cod', 'l3Desc'];
    }

    this.pageSize = 10;
    this.setOffsetInSession();
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.isMocked) {
      this.listData = new MatTableDataSource(this.dataSource);
      this.listData.paginator = this.paginator;
      this.listData.sort = this.sort;
    } else {
      this.getPageSubscribe = this.sl5AnagrafService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }
  filterTable() {
    this.getAll(this.offset);
  }

  resetTable() {
    this.filter = new L3Model();
    this.getAll(new Offset(10, 0));
  }
  openDialog(id: number) {
    const layerData = this.dataSource.find(data => data.id === id) as L3Model;
    const list: GenericArray[] = [
      { id: 'L3 Cod', value: layerData.cod.toString() },
      { id: 'L3 Description', value: layerData.description.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.sl5AnagrafService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('L3 with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('L3 cannot be deleted', 'Alert');
            }


          }, error => {
            toastr.error('L3 with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    console.log(dataFiltered);
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('sl5Offset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('sl5Offset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }
}
